import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_STATS } from './salesData';
import { POSTRES_IMAGE_URL } from '../utils/headMeta';

/** Cierre de la página: último recordatorio de la oferta y del botón de compra. */
export function FinalCta() {
  return <section className="relative w-full overflow-hidden border-b border-line bg-ink" data-id="element-62" data-mp="15d41ibyj30pz">
      <img src={POSTRES_IMAGE_URL} alt="" aria-hidden loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-63" data-mp="1jcljo8hbjfqd" />
      <div className="absolute inset-0 bg-ink/80" aria-hidden data-id="element-64" data-mp="1t37t1kyfza0m" />

      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 sm:py-24" data-id="element-65" data-mp="1t4r9bbk3ll2e">
        <h2 className="font-condensed text-[2.3rem] uppercase leading-[0.95] text-bone sm:text-[3.6rem]" data-id="element-66" data-mp="1o5y4s8msh4ed">
          Mantenerte en cetosis
          <span className="block text-glow-gold" data-id="element-67" data-mp="1x51onets5ntx">no tiene que ser aburrido</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[1.02rem] leading-relaxed text-ash" data-id="element-68" data-mp="n64apm41nokv">
          500 recetas de panes, pizzas, pastas y postres keto para elegir qué comés hoy, mañana y el
          resto del año.
        </p>

        <ul className="mx-auto mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-69" data-mp="x2qyainr8tql">
          {HERO_STATS.map(stat => <li key={stat.etiqueta} className="flex items-baseline gap-2" data-id="element-70" data-mp="120sg709g2n0h">
              <span className="font-condensed text-2xl leading-none text-gold" data-id="element-71" data-mp="163xdmoeo3yi9">{stat.valor}</span>
              <span className="font-display text-[0.56rem] uppercase tracking-editorial text-bone/70" data-id="element-72" data-mp="1b1yynevnm7wd">
                {stat.etiqueta}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 flex max-w-md flex-col items-center gap-5" data-id="element-73" data-mp="1kstkwj8wh7ht">
          <PriceBlock size="md" className="text-center [&>div]:justify-center" data-id="element-74" data-mp="1pth80tu0d46r" />
          <CTAButton data-id="element-75" data-mp="1ttjd7cyycfqs" />
        </div>
      </div>
    </section>;
}